(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  root.classList.add("fic-js");

  function easeOutCubic(progress) {
    return 1 - Math.pow(1 - progress, 3);
  }

  function setRevealDelays(section) {
    var revealItems = section.querySelectorAll("[data-fic-reveal]");

    revealItems.forEach(function (item, index) {
      item.style.setProperty("--fic-delay", Math.min(index * 120, 480) + "ms");
    });
  }

  function animateCircle(circle) {
    if (circle.dataset.ficAnimated === "true") {
      return;
    }

    circle.dataset.ficAnimated = "true";

    var circleFill = circle.querySelector(".fic-circle-fill");
    var counterNode = circle.querySelector("[data-fic-counter]");
    var targetValue = parseInt((circle.dataset.ficTarget || "").replace(/[^\d-]/g, ""), 10);
    var startValue = parseInt((counterNode ? counterNode.textContent : "0").replace(/[^\d-]/g, ""), 10);
    var duration = 2000;
    var circumference = 1005;
    var startTime = null;
    var finalOffset = parseFloat(getComputedStyle(circle.closest(".fic-section")).getPropertyValue("--fic-ring-offset")) || 0;

    if (!circleFill || isNaN(targetValue)) {
      return;
    }

    if (reduceMotion) {
      circleFill.style.strokeDashoffset = finalOffset;
      if (counterNode) {
        counterNode.textContent = String(targetValue);
      }
      return;
    }

    circleFill.style.strokeDashoffset = circumference;

    function frame(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutCubic(progress);
      var current = startValue + (targetValue - startValue) * eased;
      var ringOffset = circumference - (circumference - finalOffset) * eased;

      circleFill.style.strokeDashoffset = ringOffset;

      if (counterNode) {
        counterNode.textContent = String(Math.round(current));
      }

      if (progress < 1) {
        window.requestAnimationFrame(frame);
      }
    }

    window.requestAnimationFrame(frame);
  }

  function revealItem(item) {
    item.classList.add("fic-is-visible");

    if (item.matches(".fic-visual")) {
      var circle = item.querySelector("[data-fic-circle]");
      if (circle) {
        animateCircle(circle);
      }
    }
  }

  function initReveal(section) {
    var revealItems = section.querySelectorAll("[data-fic-reveal]");

    setRevealDelays(section);

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealItems.forEach(revealItem);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          revealItem(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.ficInitialized === "true") {
      return;
    }

    section.dataset.ficInitialized = "true";
    initReveal(section);
  }

  function initAll() {
    document.querySelectorAll("[data-fic-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector("[data-fic-section]"));
  });
})();
